import React, { useState } from "react";
import { Form, Row, Col, Input, notification, Alert } from "antd";
import { Link } from "react-router-dom";
import axios from "axios";
import RegisterImage from "../assets/images/register.svg";
import { LoadingOutlined } from "@ant-design/icons";

const Register = (props) => {
  const [loading, setLoading] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isAlreayExist, setAlreayExist] = useState(false);
  const onSignup = (values) => {
    setLoading(true);
    const formData = {
      email: values.email,
      password: values.password,
      firstName: values.firstName,
      lastName: values.lastName,
    };
    axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${process.env.REACT_APP_BASE_URL}mfb/rest/signup/signup_user`,
      data: formData,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
      .then((res) => {
        console.log("res", res);
        if (res.status == 200) {
          setLoading(false);
          setIsEmailSent(true);
        }
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        setAlreayExist(true);
        setTimeout(() => {
          setAlreayExist(false);
        }, 3000);
      });
  };
  return (
    <div className="welcome-page fullscreen">
      <div className="welcome-container">
        <div className="login-wrap">
          <Row gutter={48} align="middle">
            <Col span={14}>
              <img src={RegisterImage} alt="" />
            </Col>
            <Col span={10}>
              <div className="login-box">
                <h1>Register Here :)</h1>
                <p>
                  To Keep connected with us please register with your personal
                  email address and password.
                </p>
                <br />
                <Form
                  layout="vertical"
                  onFinish={onSignup}
                  autoComplete="off"
                  hideRequiredMark
                >
                  <Row gutter={48} align="middle">
                    <Col span={12}>
                      <Form.Item
                        name="firstName"
                        label="First Name"
                        rules={[
                          {
                            required: true,
                            message: "Please input your First Name!",
                          },
                        ]}
                      >
                        <Input size="large" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="lastName"
                        label="Last Name"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Last Name!",
                          },
                        ]}
                      >
                        <Input size="large" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Email!",
                      },
                    ]}
                  >
                    <Input size="large" />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password size="large" />
                  </Form.Item>
                  <Form.Item
                    name="confirm"
                    label="Confirm Password"
                    dependencies={["password"]}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Please confirm your password!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }

                          return Promise.reject(
                            new Error(
                              "The two passwords that you entered do not match!"
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password size="large" />
                  </Form.Item>
                  <Row gutter={15} align="middle">
                    <Col span={12}>
                      <button className="btn btn-theme" htmltype="submit">
                        {" "}
                        {loading && <LoadingOutlined />} Register
                      </button>
                    </Col>
                    <Col span={12} className="text-right">
                      <Link to="/Login" className="link">
                        Already a member?
                      </Link>
                    </Col>
                  </Row>
                </Form>
                {isEmailSent && (
                  <Alert
                    className="mt-20"
                    message="Email sent! please check your inbox to confirm"
                    type="success"
                    showIcon
                  />
                )}
                {isAlreayExist && (
                  <Alert
                    className="mt-20"
                    message="This email is already an account. Please log in or get help from our team"
                    type="error"
                    showIcon
                  />
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default Register;
